export function hasFeature(name: "payment") {
    if (name === "payment") return true;
    return false;
}